import {APIClient } from "./api_helper";

import * as url from "./url_helper";

const api = new APIClient();

// Register Method
export const postRegister = data => api.create(url.POST_REGISTER, data);
export const getVerifyEmail = token => api.create(url.GET_VERIFY_EMAIL(token));

// Login Method
export const login = data => api.create(url.LOGIN, data);

// postForgetPwd
export const postFakeForgetPwd = data => api.create(url.POST_FAKE_PASSWORD_FORGET, data);

// Edit profile
export const postJwtProfile = data => api.create(url.POST_EDIT_JWT_PROFILE, data);

// Register Method

// postForgetPwd
export const postJwtForgetPwd = data => api.create(url.POST_FAKE_JWT_PASSWORD_FORGET, data);

